<template>
  <div class="WelcomePage">
    <Header classes="pb-18" />
    <div class="multi-button">
      <div style="align-content: center; justify-items:center; height:85vh ;">
        <div class="container margin_60_40">
          <div class="main_title center">

            <h2 style="color:#fff; font-weight: 700; font-size: 24px; ">HI THERE!</h2>
            <p style="color:#dee2e6; font-weight: 200; font-size: 14px;">Select a portal to continue to Rooms</p>
          </div>

          <div class="custom-row">
            <div class="col" @click="AllRoomsNavigate">
              <a class="box_topic rooms" href="#0">
                <i aria-hidden="true" class="icon_grid-3x3 fs1 icon_2_style"></i>
                <h3>All Rooms</h3>
                <p>
                  See All Rooms View / Book / Food Order
                </p>
              </a>
            </div>

            <div class="col" @click="AllRoomsReservedNavigate">
              <a class="box_topic tickets" href="#0">
                <i aria-hidden="true" class="icon_grid-3x3 fs1 icon_2_style"></i>
                <h3>Reservations</h3>
                <p>
                  See All Reserved Rooms View
                </p>
              </a>
            </div>
          </div>
        </div>
        <!-- /container -->
      </div>
    </div>
  </div>
</template>

<script>
import { Header } from "@/components/index.js";
export default {
  components: {
    Header,
  },
  methods: {
    AllRoomsNavigate() {
      this.$router.push({
        path: "/rooms-booking",
        query: { addRooms: "1" },
      });
    },

    AllRoomsReservedNavigate() {
      this.$router.push({
        path: "/all-reserved-rooms/",
      });
    },
    roomNavigate() {
      this.$router.push({
        path: "/rooms-filter",
      });
    },
    tableNavigate() {
      this.$router.push({
        path: "/tables",
      });
    },

    kitchenNavigate() {
      this.$router.push({
        path: "/kitchen-tickets",
      });
    },
  },
};
</script>
<style scoped>
.center-takeaway {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 25%;
  -ms-transform: translate(-25%, -25%);
  transform: translate(-25%, -25%);
}

.center-room {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.center-table {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 75%;
  -ms-transform: translate(-75%, -75%);
  transform: translate(-75%, -75%);
}

body {
  background-color: #e0e5ec;
  height: 100vh;
  margin: 0;
  display: grid;
  place-items: center;
}

.effect {
  /* background-color: #e0e5ec; */
  /* border: none; */
  /* border-radius: 6px; */
  /* box-shadow: 9px 9px 16px rgb(163, 177, 198, 0.6), */
  /* -9px -9px 16px rgba(255, 255, 255, 0.5); */
  /* color: #a232b6; */
  /* font-weight: 700; */
  /* height: 150px; */
  /* margin-bottom: 50px; */
  /* margin-right: 50px; */
  /* overflow: hidden; */
  /* position: relative; */
  /* text-transform: uppercase; */
  /* width: 200px; */
}

.effect:after {
  content: "";
  position: absolute;
  top: 0;
  left: 30px;
  width: 80%;
  height: 80%;
  opacity: 0;
  transform: translateX(-50%);

  background: rgba(255, 255, 255, 0.13);
  background: linear-gradient(to right,
      rgba(255, 255, 255, 0.13) 0%,
      rgba(255, 255, 255, 0.13) 77%,
      rgba(255, 255, 255, 0.5) 92%,
      rgba(255, 255, 255, 0.3) 100%);
}

.effect:hover:after {
  opacity: 1;
  top: 0;
  left: 30px;
  transform: translateX(0);
  transition: transform 0.7s ease, opacity 0.15s ease;
}

.effect:active:after {
  opacity: 0;
}

.icon_2_style {
  padding: 20px;
  font-size: 50px;
}
</style>
